export default {
  "Spinner": "_Spinner_11pbl_11",
  "rotate": "_rotate_11pbl_1",
  "Dot": "_Dot_11pbl_21",
  "bounce": "_bounce_11pbl_1",
  "DotTwo": "_DotTwo_11pbl_32"
};import "ni:sha-256;ejEV6xU353CqA8OqXAIrteKaeSbUO7bPnpMHK_WSOaE";